import React from 'react';

import styled from 'styled-components/macro';

import { tokens } from '@olist/design-system-tokens';

import { Content, LogoSvg } from 'components/general';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0 ${tokens.spacing[500]};
  width: 100%;
`;

interface Props {
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const PageLayout: React.FC<Props> = (props: Props) => {
  const { children, footer } = props;

  return (
    <Container>
      <LogoSvg viewBox="0 0 80 32" aria-labelledby="logoTitle logoDesc">
        <title id="logoTitle">olist</title>
        <desc id="logoDesc">olist logo</desc>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.1321 0H43.1762V5.08167H37.1321V0ZM26.632 0.00415039H32.6761V31.4968H26.632V0.00415039ZM0 20.7047C0 14.4668 5.13314 9.4094 11.4644 9.4094C17.7957 9.4094 22.9288 14.4668 22.9288 20.7047C22.9288 26.9426 17.7957 32 11.4644 32C5.13314 32 0 26.9426 0 20.7047ZM5.83479 20.7027C5.83479 23.767 8.35622 26.2493 11.4644 26.2493C14.5726 26.2493 17.094 23.767 17.094 20.7027C17.094 17.6383 14.5726 15.1561 11.4644 15.1561C8.35417 15.1561 5.83479 17.6383 5.83479 20.7027ZM56.3312 18.1012C54.4581 17.3452 52.7983 16.6316 52.7983 15.245C52.7983 14.1959 53.82 13.5653 54.9689 13.5653C56.6718 13.5653 58.2454 14.4041 59.3963 15.4128L61.8993 10.9678C59.3696 9.47203 57.9499 8.90403 54.971 8.90403C50.8842 8.90403 46.9697 11.172 46.9697 15.6634C46.9697 19.5262 49.9056 21.0382 52.587 22.1722C52.8366 22.2811 53.0841 22.3863 53.3267 22.4894L53.3268 22.4895C55.2356 23.301 56.8441 23.9848 56.8441 25.3639C56.8441 26.7081 55.2274 27.2963 53.9924 27.2963C51.8218 27.2963 50.4164 26.3301 48.7136 24.6928L46.305 28.9093C48.8346 30.9024 50.8001 31.9979 54.2899 31.9979C58.6311 31.9979 62.8882 29.7724 62.8882 24.901C62.8861 20.7649 59.3284 19.3191 56.4562 18.152L56.3312 18.1012ZM37.1322 9.4094H43.1762V31.4967H37.1322V9.4094ZM78.1274 26.2897C77.3622 26.6677 76.638 26.9204 75.7004 26.9204C74.4243 26.9204 73.9134 26.122 73.7431 24.8202C73.659 24.1896 73.659 23.6034 73.659 22.9303V14.3638H79.3625V9.40946H73.659V4.53801H68.5505L67.615 9.40946H64.9335V14.3638H67.615V23.5589C67.615 24.8606 67.7011 26.1624 68.0396 27.2539C68.848 30.1101 71.1889 31.998 74.6787 31.998C76.4246 31.998 78.5521 31.5351 79.9985 30.6963L78.1274 26.2897Z"
          fill="#0C29D0"
        />
      </LogoSvg>
      <Content>{children}</Content>
      {footer}
    </Container>
  );
};

export { PageLayout };
